import {put, takeLatest, call} from 'redux-saga/effects';
import {SUCCESS_KEY} from 'constants/keys';
import {
  getDashboardRequest,
  getDashboardFailure,
  getDashboardSuccess,
  getDashboardRequestParams,
  getDashboardSuccessResponse,
} from 'redux/slices/projectAnalyticsSlice';
import {getPojectDashboard} from 'services/api';

/**
 * types for get projects
 */
type GetProjectDashboardRequestAction = {
  type: typeof getDashboardRequest.type;
payload: getDashboardRequestParams;
};

type GetProjectsDashboardResponse = {
  status: string;
} & getDashboardSuccessResponse;

/**
 * saga function for dashboard status
 */
function* dashboardStatus(action: GetProjectDashboardRequestAction): Generator {
  try {
    const response: GetProjectsDashboardResponse = yield call(
      getPojectDashboard,
      action.payload,
    );
    if (response.status === SUCCESS_KEY) {
      yield put(getDashboardSuccess(response));
    } else {
      yield put(getDashboardFailure(response.status_code));
    }
  } catch (error) {
    yield put(getDashboardFailure('E-10001'));
  }
}

export function* projectAnalyticsSaga() {
  yield takeLatest(getDashboardRequest.type, dashboardStatus);
}
